import {gql} from '@apollo/client'

export const GET_GROUPS = gql`
  query GetGroups($q: String) {
    groups(q: $q) {
      id
      name
      colour
      numOfDraftAccounts
      numOfActiveAccounts
      numOfArchivedAccounts
    }
  }
`
